import { Box, Typography } from '@mui/material';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { styled } from '@mui/material/styles';
import Slider from 'react-slick';

export const RemoveIcon = styled(RemoveCircleOutlineIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.colors.primary.slalomBlue,
}));

export const SelectedImage = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  objectPosition: 'center',
  width: '100%',
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  borderRadius: '8px',
}));

export const MultiSelectedImage = styled('img')(({ theme }) => ({
  width: "100%",
  height: '100%',
  [theme.breakpoints.up("tablet")]: {
    maxHeight: '175px',
  },
  [theme.breakpoints.up("desktop")]: {
    maxHeight: '230px',
  },
  objectFit: 'contain',
  borderRadius: '8px',
}));

export const CurrentTimeText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  color: theme.colors.action.modalClose,
}));

export const AddPhotoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.7,
  },
}));

export const AddIcon = styled(AddCircleOutlineIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.colors.primary.slalomBlue,
}));

export const RightArrowIcon = styled(ChevronRightIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.colors.primary.slalomBlue,
}));

export const LeftArrowIcon = styled(ChevronLeftIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.colors.primary.slalomBlue,
}));


export const CaptionText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
}));

export const UploadPhotoHeaderText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const UploadPhotoSubText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  margin: `0 ${theme.spacing(-3)}`,
  padding: `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(1)}`,
  boxShadow: `0px -6px 20px -6px ${theme.colors.action.hoverShadow}`,
}));

export const InnerContainer = styled(Box)(({ theme }) => ({
  width: 'auto',
  height: 'auto',
  backgroundColor: theme.colors.neutral.lightGray,
  alignItems: "center",
  display: "flex",
  flexDirection: "column"
}));

export const InnerContainerItems = styled(Typography)(({ theme }) => ({
  paddingTop: "80px",
  paddingBottom: "80px",
  position: 'relative',
}));

export const CustomSlider = styled(Slider)`
  .slick-prev::before,
  .slick-next::before {
    color: black;
  }
`;
